const experiments = require('./experiments');
const env = require('./env');
const { Position: positionIds } = require('./positions');
const { routes } = require('./routes');

const Config = {
    api: {
        keys: {
            googleMaps: 'AIzaSyCcROpb0sbwtCyQnxNwNA576uNxnlqUqUs',
            luskOrganizationID: '5c35b10d71e3c4001386e42a',
        },
        postCandidate: `https://app.recruitis.io/api2/answers`,

        sendInquiryForm: `https://formspree.io/f/mbjpdlgl`,
        signupNewsLetter: `https://ackee.us17.list-manage.com/subscribe/post-json?u=79ddfc580d7d28fe0971e00ef&amp;id=a975ea0c2c&`,

        fetchPosition: 'https://app.recruitis.io/api2/jobs/:id',

        publicATSToken: 'Bearer 2bd39d515f98abe6bf2cf257334bd2d9f8307eef.c.8652.b039d6b2642ad47b4057e7802c3681a4',

        recruitisSourceId: {
            CAREER_FORM: 1041,
        },
    },
    departments: {
        web: 'web',
        mobile: 'mobile',
        general: 'general',
        design: 'design',
    },
    linkTypes: {
        localized: 'localized',
        external: 'external',
    },
    links: {
        csHome: 'https://ackee.cz',
        enHome: 'https://ackee.agency',
        deHome: 'https://www.ackee.de/',
        dePhone: '+493054907495',
        deInfoMail: 'info@ackee.de',
        blockchain: 'https://www.ackeeblockchain.com/',
    },
    routes,
    experiments,
    positionIds,
    env,
};

module.exports = Config;
